<!-- Footer template -->
<template>
  <v-footer dark padless app inset>
    <v-card class="flex" flat tile color="black" :elevation="10">
      <v-card-text class="py-2 white--text text-center">
        {{ new Date().getFullYear() }} - <strong>Bitonic Systems Oy</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {};
</script>

<style></style>
